const DO_FLASH = 'DO_FLASH';
const CLEAR_FLASH = 'CLEAR_FLASH';

module.exports = {
	DO_FLASH,
	CLEAR_FLASH,

	doFlash(flashType, title, message) {
		return {
			type: DO_FLASH,
			payload: {
				title,
				type: flashType,
				message
			}
		};
	},

	clearFlash() {
		return { type: CLEAR_FLASH };
	}
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/actions/flash.js